export default {
	useYnOptions: [],
	searchParams: { useYn: 'Y', widgetMstFileId: '', widgetTitle: '' },
	widgets: {
		currentPage: 1,
		pageUnit: null,
		totalSize: 0,
		data: []
	}
};
